
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-started/logo",
      function () {
        return require("private-next-pages/get-started/logo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-started/logo"])
      });
    }
  